export default __webpack_public_path__ + "static/media/balance-wellness-uniqueness.0e6ed704.md";